<template>
    <DefaultLayout>
        <Error />
    </DefaultLayout>
</template>
<script setup lang="ts">
    import Error from '~/components/ui/atom/error.vue'
    import DefaultLayout from '~/layouts/default.vue'
</script>
